
<template>
  <!--物业公司管理-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="property_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    </x-tabula>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'company',
  data () {
    return {
      searchList: [
        { label: '', props: ['keywords'], placeholder: '公司名、手机号', inputType: 'input' },
        { label: '', props: ['area_id'], placeholder: '选择省市', options: [], inputType: 'cascader', changeOnSelect: true },
        { label: '', props: ['verify_status'], placeholder: '状态', options: [], inputType: 'select' },
        { label: '', props: ['create_date'], placeholder: ['审核时间', '审核时间'], options: [], inputType: 'datePick' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' }
      ],
      rowOptList: [
        { text: '', handle: (row) => this.toAudit(row), customRender: true, key: 'audit' },
        { text: '修改', handle: (row) => this.$children[0].toEdit(row, ['verify_status']), key: 'edit' },
        { text: '删除', handle: (row) => this.$children[0].showDeleteConfirm(row), key: 'delete' }
      ],
      columns: [
        { title: '所在城市', dataIndex: 'address', align: 'left', width: '' },
        { title: '物业公司名称', dataIndex: 'property_full_name', align: 'left', width: '' },
        { title: '联系人手机', dataIndex: 'mobile_phone', align: 'left', width: '' },
        { title: '审核人', dataIndex: 'verify_user', align: 'left', width: '' },
        { title: '审核时间', dataIndex: 'check_time', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_txt', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: '',
        area_id: '',
        verify_status: '',
        create_date: []
      },
      listApi: {
        url: '/property',
        resHandle: this.resHandle,
        searchHandle: '' // this.searchHandle
      },
      addHandleParam: {
        route: 'addCompany',
        title: '编辑物业公司'
      },
      deleteParam: {
        url: '/property',
        param: {pk_key: 'property_id', pk_val: ''},

        title: '物业公司',
        key: 'property_full_name'
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this.propertyManageSelect([{index: 2, key: 'check_status'}]);
      this.regionSelect(1);
    },
    toAudit (row) {
      this.$router.push({
        name: 'auditCompany',
        query: {
          title: row.verify_status !== 0 ? '物业公司详情' : '',
          id: row.property_id,
          status: `${row.verify_status}`
        }
      });
    },
    resHandle (res) {
      res.forEach((ele) => {
        ele.address = `${ele.province_name} ${ele.city_name}`;
      });
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/property/company/company.vue